import React from 'react';
import { useCustomerDetails } from '../api/getCustomerDetails';
import { AvatarSkeleton, BlobImage } from 'components/Elements';

export const UserAvatar = ({ userId, className = '' }) => {
  const { data, isLoading } = useCustomerDetails({ id: userId });

  if (isLoading) return <AvatarSkeleton className={className} />;

  const user = data?.userDetails;
  const { photo, firstName, lastName } = user || {};

  const getInitials = () =>
    `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();

  return (
    <div
      className={`min-w-8 min-h-8 rounded-full flex items-center justify-center
        text-xs font-semibold text-white bg-white/10 dark:bg-black/20
        backdrop-blur-md border border-white/20 shadow-md overflow-hidden ${className}`}
    >
      {photo ? (
        <BlobImage dataURI={photo} alt={`${firstName} ${lastName}`} />
      ) : (
        <span>{getInitials()}</span>
      )}
    </div>
  );
};
